import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconLightning: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11.0071 22C10.9078 22 10.8085 22 10.7092 22C10.3121 21.8003 10.0142 21.4008 10.0142 21.0013V15.0089H6.04255C5.64539 15.0089 5.34752 14.8092 5.14894 14.5095C4.95035 14.2099 4.95035 13.8104 5.14894 13.5108L12.0993 2.52481C12.3972 2.12532 12.8936 1.92558 13.2908 2.02545C13.6879 2.2252 13.9858 2.62469 13.9858 3.02418V9.01654H17.9574C18.3546 9.01654 18.6525 9.21629 18.8511 9.51591C19.0496 9.81553 19.0496 10.215 18.8511 10.5146L11.9007 21.5006C11.7021 21.8003 11.305 22 11.0071 22ZM7.82979 13.0115H11.0071C11.6028 13.0115 12 13.4109 12 14.0102V17.6056L16.1702 11.014H12.9929C12.3972 11.014 12 10.6145 12 10.0153V6.41985L7.82979 13.0115Z',
    })
  )
}
